import { render, staticRenderFns } from "./EnvioDocumentacao.vue?vue&type=template&id=47dd5d6f&"
import script from "./EnvioDocumentacao.vue?vue&type=script&lang=js&"
export * from "./EnvioDocumentacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports